var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('v-alert',{attrs:{"type":_vm.alertType,"dismissible":""},model:{value:(_vm.localAlert),callback:function ($$v) {_vm.localAlert=$$v},expression:"localAlert"}},[_vm._v("\n        "+_vm._s(_vm.alertMsg)+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }